module.exports = __webpack_public_path__ + "5e066689068f63f39f832fe10a600eb6.jpg";